export const DS_FILE_UPLOAD_CLASSES = {
  Root: "ds-file-upload",
  Dropzone: "ds-file-upload__dropzone",
  Input: "ds-file-upload__input",
  Icon: "ds-file-upload__icon",
  Title: "ds-file-upload__title",
  Description: "ds-file-upload__description",
  ErrorList: "ds-file-upload__error-list",
  Files: "ds-file-upload__files",
  Progress: "ds-file-upload__progress",
  RemoveAll: "ds-file-upload__remove-all",
  PageDropOverlay: "ds-file-upload__page-drop-overlay",
  PageDropzone: "ds-file-upload__page-dropzone",
  Default: "ds-file-upload--default",
  DragActive: "ds-file-upload--active",
  Loading: "ds-file-upload--loading",
  Divider: "ds-file-upload--divider",
} as const;
